import React from "react";
import {
  TextField,
  Box,
  MenuItem,
  Select,
  FormHelperText,
} from "@mui/material";
import styles from "../../../styles/gri/general.module.css";
import { set } from "lodash";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import DateField from "../../../Components/Masters/DateField";
import { Indent } from "docx";
import SectionHeading from "../GRI300/GRI308/SectionHeading";
const TextFieldData = ({
  title,
  index,
  gridTemplateColumns,
  inputData,
  fromData,
  setFromData,
  setErrors,
  errors,
  disabled,
  hide,
}) => {
  const today = dayjs();
  const handleChange = (e, type) => {
    const { value, name } = e.target;
    console.log(name, value, type, "changedValue");
    if (type === "number") {
      if (!/^\d*$/.test(value)) return;
    } else if (type === "percentage") {
      if (!/^\d*$/.test(value)) return;
      const numericValue = Number(value);
      if (numericValue < 0 || numericValue > 100) return;
    }
    const [main, sub] = name.split(".");
    console.log(main, sub, "checking the value of object from");
    setFromData((prev) => {
      if (sub) {
        // Update the main nested object with the subfield value
        return {
          ...prev,
          [main]: {
            ...prev[main],
            [sub]: value, // Update the specific subfield
          },
        };
      } else {
        // If no main (i.e., direct field), update the value directly
        return {
          ...prev,
          [main]: value,
        };
      }
    });
    setErrors((prev) => {
      if (sub) {
        return {
          ...prev,
          [`${main}.${sub}`]: "",
        };
      } else {
        return {
          ...prev,
          [main]: "", // Clear the specific error message
        };
      }
    }); // Clear the error for the specific field if the user enters a valid value
  };
  console.log("object1", fromData);

  function calculateRatio(a, b) {
    function gcd(x, y) {
      return y === 0 ? x : gcd(y, x % y);
    }

    if (b === 0) return "N/A"; // Prevent division by zero

    const divisor = gcd(a, b);
    return `${a / divisor}:${b / divisor}`;
  }

  const calculateUpdatedRatio = (prev, main, sub, updatedValue) => {
    const annual = prev[main]?.annual;
    const allEmployees = prev[main]?.allEmployees;
    const topExecutive = prev[main]?.topExecutive;
    const mediumPercentage = prev[main]?.mediumPercentage;

    let ratio = "";

    if (sub === "annual" || sub === "allEmployees") {
      const newAnnual = sub === "annual" ? updatedValue : annual;
      const newAllEmployees =
        sub === "allEmployees" ? updatedValue : allEmployees;
      if (
        newAnnual !== "" &&
        newAllEmployees !== "" &&
        !isNaN(newAnnual) &&
        !isNaN(newAllEmployees)
      ) {
        ratio = calculateRatio(Number(newAnnual), Number(newAllEmployees));
      }
    } else {
      if (
        topExecutive !== "" &&
        mediumPercentage !== "" &&
        !isNaN(topExecutive) &&
        !isNaN(mediumPercentage)
      ) {
        ratio = calculateRatio(Number(topExecutive), Number(mediumPercentage));
      }
    }

    console.log(ratio, "ratios");

    return ratio;
  };
  const handleChangeNumber = (e) => {
    const { value, name } = e.target;
    console.log(name, value, "changed");
    const [main, sub] = name.split(".");
    console.log(main, sub, "checking the value of object from");

    if (!/^\d*$/.test(value)) return; // Allow only numbers
    setFromData((prev) => {
      const updatedValue = value === "" ? "" : Number(value);
      console.log(prev, "previous value");

      // Ensure main object exists in prev state
      const updatedMain = prev[main] || {};

      // Calculate the updated ratio if `ration` exists in `prev`
      console.log(prev, prev?.main, main, "userRatio");
      const shouldIncludeRation = "ration" in prev[main]; // Check if `ration` exists
      const ratio = shouldIncludeRation
        ? calculateUpdatedRatio(
            { ...prev, [main]: { ...updatedMain, [sub]: updatedValue } },
            main,
            sub,
            updatedValue
          )
        : null;
      console.log(shouldIncludeRation, prev?.main, main, "userRatio");
      return {
        ...prev,
        [main]: {
          ...updatedMain,
          [sub]: updatedValue,
          ...(shouldIncludeRation ? { ration: ratio } : {}), // Conditionally add `ration`
        },
      };
    });
    // setFromData((prev) => {
    //   const updatedValue = Number(value);
    //   console.log(prev,"previous value")
    //   // Ensure main object exists in prev state
    //   const updatedMain = prev[main] || {};

    //   // Calculate the updated ratio
    //   const ratio = sub
    //     ? calculateUpdatedRatio(
    //         { ...prev, [main]: { ...updatedMain, [sub]: updatedValue } },
    //         main,
    //         sub,
    //         updatedValue
    //       )
    //     : "";

    //   return {
    //     ...prev,
    //     [main]: {
    //       ...updatedMain,
    //       [sub]: updatedValue,
    //       ...(sub ? { ration: ratio } : {}),
    //     },
    //   };
    // });

    setErrors((prev) => ({
      ...prev,
      [sub ? `${main}.${sub}` : main]: "",
    }));
  };

  const handleCurrencyChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value, "changed");
    const [main, sub] = name.split(".");
    setFromData((prev) => {
      return {
        ...prev,
        [main]: { [sub]: value },
      };
    });
  };

  console.log("object123", fromData);
  return (
    <>
      {/* <p className={styles.main_heading}>{title}</p> */}
      {index ? (
        // <p
        //   className={styles.main_heading}
        //   style={{ display: "flex", textDecoration: "none" }}
        // >
        //   <p
        //     // className={styles.main_heading}
        //     style={{
        //       marginRight: index ? "0.3rem" : null,
        //       marginBottom: index ? "0rem" : null,
        //       textDecoration: index ? "none" : null,
        //       width: index ? "7%" : null,
        //       fontWeight: "bold",
        //     }}
        //   >
        //     {" "}
        //     {index}{" "}
        //   </p>
        //   {title}
        // </p>
         <SectionHeading text={`${index} ${title}`} />
      ) : (
        <p className={styles.main_heading}>{title}</p>
      )}
      {console.log(inputData, "inputData")}
      {inputData.map((item) => {
        const name = item?.subfieldName
          ? `${item.subfieldName}.${item.fieldName}`
          : item.fieldName;
        const value = item?.subfieldName
          ? `[${item.subfieldName}][${item.fieldName}]`
          : item.fieldName;
        console.log(fromData, item, "values found");

        return (
          <>
            <SectionHeading text={`${item?.index} ${item.heading}`} />

            {item.subheading ? (
              <SectionHeading text={`${item?.subindex} ${item.subheading}`} />
            ) : null}
            <Box sx={{ marginLeft: item.subheading ? "15px" : "1rem",marginTop:"0px" }}>
              {item.fieldName && (
                <TextField
                  placeholder={item?.placeholder?
                    item?.placeholder
                    :"Enter Text"}
                  variant="outlined"
                  // size="small"
                  minRows={1}
                  multiline
                  name={name}
                  disabled={disabled}
                  value={
                    item?.subfieldName
                      ? fromData?.[item.subfieldName]?.[item.fieldName]
                      : fromData?.[item?.fieldName]
                  }
                  //  value={item.subfieldName?fromData?.[item.subfieldName]?.[item.fieldName] : fromData?.item?.fieldName}
                  onChange={(e) =>
                    handleChange(e, item.type ? item.type : "text")
                  }
                  fullWidth
                  // error={!!errors[name]} // Shows error if the field has an error
                  // helperText={errors[name] || ""}
                  InputProps={{
                    sx: {
                      // fontSize: "0.875rem",
                      // lineHeight: "1.4",
                      paddingLeft: "10px", // <- padding inside the input box
                    },
                  }}
                  sx={{
                    fontSize: "14px",
                    "& .MuiOutlinedInput-root": {
                      minHeight: "40px",
                      padding: 0,
                      "& textarea": {
                        paddingLeft: "10px", // <- for multiline textarea
                      },
                    },
                  }}
                />
              )}
              {item.fields &&
                item.type !== "flex" &&
                item.fields.map((value) => {
                  const nameofsubfileds = item.subfieldName
                    ? `${item.subfieldName}.${value.fieldName}`
                    : value.fieldName;
                  return (
                    <>
                      <SectionHeading
                        text={`${value?.index} ${value.subheading}`}
                      />
                      <TextField
                        placeholder="Enter Text"
                        variant="outlined"
                        // size="small"
                        name={nameofsubfileds}
                        minRows={1}
                        disabled={disabled}
                        multiline
                        value={
                          item.subfieldName
                            ? fromData?.[item.subfieldName]?.[value.fieldName]
                            : fromData?.[value.fieldName]
                        }
                        onChange={(e) => handleChange(e, "text")}
                        // error={!!errors[nameofsubfileds]} // Shows error if the field has an error
                        // helperText={errors[nameofsubfileds] || ""}
                        InputProps={{
                          sx: {
                            // fontSize: "0.85rem",
                            // lineHeight: "1.4",
                            paddingLeft: "10px", // <- padding inside the input box
                          },
                        }}
                        sx={{
                          fontSize: "14px",
                          width: "100%",

                          "& .MuiOutlinedInput-root": {
                            minHeight: "40px",
                            padding: 0,
                            "& textarea": {
                              paddingLeft: "10px", // <- for multiline textarea
                            },
                            marginLeft: "10px",
                          },
                        }}
                      />
                    </>
                  );
                })}
              {item.type === "flex" && (
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: gridTemplateColumns
                      ? gridTemplateColumns
                      : "1fr 2fr 0.5fr", // Three columns
                    gap: "20px", // Spacing between columns
                    alignItems: "center", // Align elements properly
                    // padding: "10px",
                  }}
                >
                  {item.fields
                    ? item.fields.slice(0, 3).map((value, index) =>
                        value?.subheading ? (
                          <p
                            key={index}
                            className={styles.ques_heading}
                            sx={{
                              marginBottom: "1px",
                              marginLeft: "5px",
                              fontWeight: "bold",
                            }}
                          >
                            {value.subheading}
                          </p>
                        ) : null
                      )
                    : null}
                  {item.fields &&
                    item.fields.slice(0, 2).map((value, index) => {
                      const nameofsubfields = item.subfieldName
                        ? `${item.subfieldName}.${value.fieldName}`
                        : value.fieldName;

                      return (
                        <Box key={index}>
                          {value.type === "select" ? (
                            <>
                              <Select
                                name={`${item.subfieldName}.${value.currencyFieldName}`}
                                value={
                                  fromData?.[item.subfieldName]?.[
                                    value.currencyFieldName
                                  ] || ""
                                }
                                onChange={handleCurrencyChange}
                                displayEmpty
                                size="small"
                                disabled={disabled}
                                sx={{ width: "150px" }}
                              >
                                <MenuItem value="">
                                  <em>{value?.placeholder?
                                  value?.placeholder
                                  :"Select"}</em>
                                </MenuItem>
                                {value?.currency?.map((currencyOption) => (
                                  <MenuItem
                                    key={currencyOption}
                                    value={currencyOption}
                                  >
                                    {currencyOption}
                                  </MenuItem>
                                ))}
                              </Select>
                              {errors ? (
                                <FormHelperText>
                                  {errors?.[value.currencyFieldName]}
                                </FormHelperText>
                              ) : null}
                            </>
                          ) : (
                            <TextField
                              placeholder="Enter Number"
                              variant="outlined"
                              fullWidth
                              size="small"
                              minRows={1}
                              multiline
                              // sx={{ pl: 2 }}
                              name={nameofsubfields}
                              disabled={disabled}
                              value={
                                item.subfieldName
                                  ? fromData?.[item.subfieldName]?.[
                                      value.fieldName
                                    ]
                                  : fromData?.[value.fieldName]
                              }
                              onChange={handleChangeNumber}
                              // error={!!errors[nameofsubfields]} // Show error if exists
                              // helperText={errors[nameofsubfields] || ""}
                              InputProps={{
                                sx: {
                                  // fontSize: "0.875rem",
                                  lineHeight: "1.4",
                                  paddingLeft: "10px", // <- padding inside the input box
                                },
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  minHeight: "40px",
                                  padding: 0,
                                  "& textarea": {
                                    paddingLeft: "10px", // <- for multiline textarea
                                  },
                                },
                              }}
                            />
                          )}
                        </Box>
                      );
                    })}

                  {/* Third column (empty) */}
                  <Box sx={{ ml: 2 }}>
                    {item?.subfieldName ===
                    "highestPaidCompensationIncreaseRatio"
                      ? fromData?.highestPaidCompensationIncreaseRatio?.ration
                      : fromData?.medianEmployeeCompensationRatio?.ration}
                  </Box>
                </Box>
              )}
              {item?.subheadings &&
                item?.subheadings.length > 0 &&
                item?.subheadings.map((items) => {
                  return (
                    <Box>
                       <SectionHeading text={`${items?.index} ${items.heading}`} />
                      <Box sx={{ marginLeft: "1rem" }}>
                        {items.type === "date" ? (
                          // <LocalizationProvider
                          //   dateAdapter={AdapterDayjs}
                          //   sx={{ padding: "10px 16px" }}
                          // >
                          //   <DatePicker
                          //     sx={{ width: "50%" }}
                          //     // views={["year"]}
                          //     maxDate={today}
                          //     format="DD/MM/YYYY"
                          //     label={"Select Year"}
                          //     size="small"
                          //     value={
                          //       dayjs(fromData?.[items?.fieldName])
                          //   }

                          //     onChange={(newValue) => {
                          //       console.log("onchnagesData", newValue)
                          //       setFromData((prev) => ({
                          //         ...prev,
                          //         [items.fieldName]: dayjs(newValue).format("DD/MM/YYYY") || "",
                          //       }));
                          //     }}
                          //     renderInput={(params) => (
                          //       <TextField
                          //         {...params}
                          //         // fullWidth
                          //         minRows={1}
                          //         multiline
                          //         size="small"
                          //       />
                          //     )}
                          //   />
                          // </LocalizationProvider>
                          <DateField
                            handleChange={({ name, value }) => {
                              console.log("onchnagesData", name, value);
                              setFromData((prev) => ({
                                ...prev,
                                [items.fieldName]: value,
                              }));
                            }}
                            width={items?.width?items?.width:"21%"}
                            name={items?.fieldName}
                            placeholder={"Select Date"}
                            value={fromData?.[items?.fieldName]}
                            errors={errors[items?.fieldName] && true}
                            disable={disabled}
                          />
                        ) : (
                          <TextField
                            placeholder="Enter Text"
                            variant="outlined"
                            size="small"
                            disabled={disabled}
                            name={
                              item.subfieldName && value.fieldName
                                ? `${item.subfieldName}.${value.fieldName}`
                                : `${items.fieldName}`
                            }
                            value={
                              item.subfieldName && value.fieldName
                                ? fromData?.[item.subfieldName]?.[
                                    value.fieldName
                                  ]
                                : items.fieldName
                                ? fromData?.[items.fieldName]
                                : fromData?.[value.fieldName]
                            }
                            minRows={1}
                            multiline
                            onChange={(e) => handleChange(e, "number")}
                            // fullWidth
                            // error={!!errors[nameofsubfileds]} // Shows error if the field has an error
                            // helperText={errors[nameofsubfileds] || ""}
                            InputProps={{
                              sx: {
                               
                                // fontSize: "0.875rem",
                                lineHeight: "1.4",
                                paddingLeft: "10px", // <- padding inside the input box
                              },
                            }}
                            sx={{
                                 width:"16%", // for 201-3
                              fontSize: "14px",
                              "& .MuiOutlinedInput-root": {
                                minHeight: "40px",
                                padding: 0,
                                "& textarea": {
                                  paddingLeft: "10px", // <- for multiline textarea
                                },
                              },
                            }}
                          />
                        )}
                      </Box>
                    </Box>
                  );
                })}
            </Box>
          </>
        );
      })}
    </>
  );
};

export default TextFieldData;
